import { getProviderById } from '@/constants/providers'
import { Game } from '@/types'
import camelToSpace from './camel-to-space'

export function getThumbnailUrl(id: string) {
  if (/^(thunderkick|softswiss|mascot|avatarux|playtech|hacksaw):/.test(id)) {
    return `https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/thumbs/${id}.webp/public`
  }

  if (id.startsWith('nolimit:')) {
    return `https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/thumbss/${id}.webp/public`
  }

  if (id.includes(':') && !id.startsWith('pragmaticexternal:')) {
    return `https://cdn.softswiss.net/i/s3/${id.replace(':', '/')}.webp`
  }

  return `https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/${id}.webp/public`
}

export function getGameDetails(id: string): Game {
  const index = id.indexOf(':')
  const isOriginal = index === -1
  const name = camelToSpace(isOriginal ? id : id.slice(index + 1))
  const thumbnailUrl = getThumbnailUrl(id)

  return {
    id,
    name,
    thumbnail: {
      url: thumbnailUrl,
    },
    provider: isOriginal ? undefined : getProviderById(id.slice(0, index)),
    path: `/games/${id}`,
    isOriginal,
  }
}

export function calculateProfit(amount: number, multiplier: number) {
  return amount * multiplier - amount
}

export function calculateEffectiveRTP(rtp?: number): string {
  if (rtp === undefined) return '0.00'

  const edge = 100 - rtp
  const value = rtp + edge / 2

  return value.toFixed(2)
}
